import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useClientMobilePageRedirect = () => {
  return usePagesRedirect('clientMobilePage');
};
